import { FolderPoundIcon } from './FolderPoundIcon';

/**
 * author: Michael Irigoyen
 * id FEA28688-AA8C-4CEE-937C-9110076B3214
 * name folder-pound
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-pound.svg
 * tags
 * - Files / Folders 
 * - Developer / Languages 
 */
export const FolderHashIcon = FolderPoundIcon;
export default FolderHashIcon